module.exports = __webpack_public_path__ + "img/dataTip.c6f30e33.png";